import React, { createContext, useContext, useEffect, useState } from 'react'

const defaults = {
  cmsName: 'WebNest',
  tagline: 'Powering your online presence',
  supportEmail: '',
  copyrightText: '© 2024 WebNest. All rights reserved.',
  logoUrl: '',
  logoUrlLight: '',
  faviconUrl: '',
  appUrl: ''
}

const BrandingContext = createContext(defaults)

export const useBranding = () => useContext(BrandingContext)

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(defaults)

  useEffect(() => {
    fetch('/api/settings/branding')
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data && !data.error) setBranding({ ...defaults, ...data }) })
      .catch(() => {})
  }, [])

  useEffect(() => {
    document.title = `${branding.cmsName} Dashboard`
  }, [branding.cmsName])

  useEffect(() => {
    if (!branding.faviconUrl) return
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = branding.faviconUrl
  }, [branding.faviconUrl])

  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  )
}
